<template>
  <div>
    <img src="../../../assets/vsu_logo_official.png" class="user-avatar center-logo">
    <h2 class="title white-text center">
      VSU PAYROLL System
    </h2>
    <h5 class="title white-text center">Login</h5>
  </div>
</template>

<script>
export default {
  name: 'PublicHeader',
  computed: {
    message() {
      return 'Page not found'
    }
  }
}
</script>
